import type { ReactElement, ReactNode } from "react";
import ReactMarkdown, { type Options } from "react-markdown";
import remarkCjkFriendly from "remark-cjk-friendly/parseOnly";
import remarkCjkFriendlyGfmStrikethrough from "remark-cjk-friendly-gfm-strikethrough/parseOnly";
import remarkGfm from "remark-gfm";

/**
 * 모델이 쓴 마크다운을 그립니다.
 *
 * **HTML은 어디에서도 해석하지 않습니다.** `rehype-raw`를 넣지 않으므로 답변에
 * 섞인 원시 HTML은 엘리먼트가 되지 못하고 버려집니다 —
 * `dangerouslySetInnerHTML`은 이 파일에 없고 추가되어서도 안 됩니다.
 *
 * 강조·목록·표를 CJK 문장에서 인식하는 규칙은 portal의 AI 답변 렌더러와 같은
 * 플러그인 묶음을 씁니다. 문법 하이라이팅은 하지 않습니다 — 색을 입히려면 언어
 * 정의 묶음을 통째로 번들해야 하고, 그 무게가 답변 한 조각이 얻는 것보다 큽니다.
 */

const REMARK_PLUGINS: Options["remarkPlugins"] = [remarkGfm, remarkCjkFriendly, remarkCjkFriendlyGfmStrikethrough];

/** 링크는 전부 도구 결과에서 온 값입니다 — 새 창과 `rel`은 선택이 아닙니다. */
const COMPONENTS: Options["components"] = {
  p: ({ children }: { children?: ReactNode }) => <p className="diagnose__answer">{children}</p>,
  ul: ({ children }: { children?: ReactNode }) => <ul className="diagnose__list">{children}</ul>,
  ol: ({ children }: { children?: ReactNode }) => <ol className="diagnose__list">{children}</ol>,
  pre: ({ children }: { children?: ReactNode }) => <pre className="diagnose__code">{children}</pre>,
  a: ({ href, children }: { href?: string; children?: ReactNode }) => (
    <a className="diagnose__link" href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
};

export function renderMarkdown(text: string): ReactElement {
  return (
    <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={COMPONENTS}>
      {text}
    </ReactMarkdown>
  );
}
